import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue';
import { computed, ref } from 'vue';
import { Checkbox } from 'Components/primitives/checkbox';
import { useValidation } from 'Components/inputs/useValidation';
export default /*@__PURE__*/ _defineComponent({
    __name: 'EnCheckbox',
    props: /*@__PURE__*/ _mergeModels({
        value: { type: null, required: false, default: undefined },
        label: { type: String, required: false, default: undefined },
        isDisabled: { type: Boolean, required: false, default: false },
        disabled: { type: Boolean, required: false, default: false },
        indeterminate: { type: Boolean, required: false, default: false },
        isSelectAll: { type: Boolean, required: false, default: false },
        staticId: { type: [String, Number, null], required: false, default: null },
        id: { type: String, required: false, default: undefined },
        rules: { type: Array, required: false, default: undefined },
        name: { type: String, required: false },
        hideDetails: { type: Boolean, required: false, default: false }
    }, {
        "modelValue": { type: [Boolean, Array], ...{ default: false } },
        "modelModifiers": {},
    }),
    emits: /*@__PURE__*/ _mergeModels(['input'], ["update:modelValue"]),
    setup(__props, { expose: __expose, emit: __emit }) {
        __expose();
        const props = __props;
        /**
         * The checked state. Use with `v-model`.
         */
        const model = _useModel(__props, "modelValue");
        // `input` mirrors `update:modelValue` for V2 EnCheckBox parity.
        const emit = __emit;
        /** An array `modelValue` turns this into a group member. */
        const isArrayModel = computed(() => Array.isArray(model.value));
        const isChecked = computed(() => isArrayModel.value
            ? model.value.includes(props.value)
            : Boolean(model.value));
        const isDirty = ref(false);
        const { errorMessage, onBlur: onValidationBlur, } = useValidation(isDirty, props, model);
        const checkboxModelValue = computed(() => props.indeterminate ? 'indeterminate' : isChecked.value);
        function onChange(_val) {
            let next;
            if (isArrayModel.value) {
                const current = model.value;
                next = current.includes(props.value)
                    ? current.filter((entry) => entry !== props.value)
                    : [...current, props.value];
            }
            else {
                // indeterminate is purely visual — reka always emits `true` from the
                // indeterminate state, but we want to toggle the actual value instead.
                next = props.indeterminate ? !isChecked.value : _val;
            }
            model.value = next;
            emit('input', next);
            isDirty.value = true;
        }
        function onBlur() {
            isDirty.value = true;
            onValidationBlur();
        }
        const __returned__ = { props, model, emit, isArrayModel, isChecked, isDirty, errorMessage, onValidationBlur, checkboxModelValue, onChange, onBlur, get Checkbox() { return Checkbox; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
